module.exports = __webpack_public_path__ + "img/loading.6b94737b.svg";